<template>
  <div>
    <PCNavbar selectIndex="4"/>
    <MobileNavBar :currentActive="3" />
    <Bsgw/>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import Bsgw from '@/components/bsgw/index.vue'
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    Bsgw
  },
}
</script>

<style>
</style>